import { useNavigate } from "react-router-dom";
import { PublicNav, PublicFooter } from "../components/PublicLayout";
import "./LandingPage.css";

const PricingPage = () => {
  const navigate = useNavigate();

  return (
    <div className="lp-root">
      <PublicNav />

      {/* Hero */}
      <section className="lp-hero" style={{ padding: "80px 20px 100px" }}>
        <div className="lp-hero-inner">
          <div className="lp-hero-badge">Pricing</div>
          <h1 className="lp-hero-title" style={{ fontSize: "3rem" }}>
            Simple, <span className="lp-hero-gradient">transparent pricing</span>
          </h1>
          <p className="lp-hero-sub">No hidden fees. No ad-spend percentages. Cancel anytime.</p>
        </div>
      </section>

      {/* Plans */}
      <section className="lp-pricing" style={{ paddingTop: 80 }}>
        <div className="lp-section-inner">
          <div className="lp-plans">

            <div className="lp-plan">
              <div className="lp-plan-name">Starter</div>
              <div className="lp-plan-price">
                <span className="lp-plan-amount">$99</span>
                <span className="lp-plan-per">/mo</span>
              </div>
              <ul className="lp-plan-features">
                <li>Up to $10,000 monthly ad spend</li>
                <li>Campaign creation wizard</li>
                <li>Audience management</li>
                <li>Performance dashboard</li>
                <li>Facebook & Instagram ads</li>
                <li>Email support</li>
              </ul>
              <button className="lp-plan-btn" onClick={() => navigate("/signup")}>Get Started</button>
            </div>

            <div className="lp-plan lp-plan-featured">
              <div className="lp-plan-badge">Most Popular</div>
              <div className="lp-plan-name">Professional</div>
              <div className="lp-plan-price">
                <span className="lp-plan-amount">$299</span>
                <span className="lp-plan-per">/mo</span>
              </div>
              <ul className="lp-plan-features">
                <li>Up to $50,000 monthly ad spend</li>
                <li>Everything in Starter</li>
                <li>Multi-account management</li>
                <li>Advanced reporting</li>
                <li>Priority support</li>
              </ul>
              <button className="lp-plan-btn lp-plan-btn-featured" onClick={() => navigate("/signup")}>Get Started</button>
            </div>

            <div className="lp-plan">
              <div className="lp-plan-name">Enterprise</div>
              <div className="lp-plan-price">
                <span className="lp-plan-amount">$999</span>
                <span className="lp-plan-per">/mo</span>
              </div>
              <ul className="lp-plan-features">
                <li>Unlimited ad spend</li>
                <li>Everything in Professional</li>
                <li>Dedicated account manager</li>
                <li>Custom onboarding</li>
                <li>Priority phone support</li>
              </ul>
              <button className="lp-plan-btn lp-plan-btn-outline" onClick={() => navigate("/contact")}>Contact Us</button>
            </div>

          </div>

          {/* FAQ */}
          <div style={{ maxWidth: 640, margin: "80px auto 0", textAlign: "center" }}>
            <h2 className="lp-section-title" style={{ fontSize: "1.75rem", marginBottom: 32 }}>Common questions</h2>
            <div style={{ display: "flex", flexDirection: "column", gap: 24, textAlign: "left" }}>
              {[
                { q: "Can I cancel anytime?", a: "Yes. Cancel from your billing settings at any time. You keep access until the end of your billing period." },
                { q: "What counts as ad spend?", a: "Ad spend is the total amount billed to your Facebook ad accounts, not what you pay Adsoar." },
                { q: "Is there a free trial?", a: "Yes — you can sign up and connect your Meta account for free. A subscription is required to publish campaigns." },
                { q: "What payment methods do you accept?", a: "All major credit and debit cards via Stripe." },
              ].map((item, i) => (
                <div key={i} style={{ borderBottom: "1px solid #e2e8f0", paddingBottom: 20 }}>
                  <div style={{ fontWeight: 700, color: "#0f172a", marginBottom: 8, fontSize: "0.95rem" }}>{item.q}</div>
                  <div style={{ color: "#64748b", fontSize: "0.9rem", lineHeight: 1.65 }}>{item.a}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="lp-cta">
        <div className="lp-cta-inner">
          <h2 className="lp-cta-title">Ready to get started?</h2>
          <p className="lp-cta-sub">Connect your Meta account and launch your first campaign today.</p>
          <button className="lp-hero-btn-main" onClick={() => navigate("/signup")}>Get Started Free</button>
          <p className="lp-hero-trust" style={{ color: "rgba(255,255,255,0.6)" }}>No credit card required</p>
        </div>
      </section>

      <PublicFooter />
    </div>
  );
};

export default PricingPage;
